import { Link } from "react-router-dom";

export const AboutUniversityConst = {
  path: "/single-page/about-university",
  title: "Об университете",
  contentJSX: (
    <>
      <p>
        <strong>Malta School of Medicine & Business (MSMB)</strong> — это современное международное образовательное учреждение,
        расположенное в Республике Мальта — стабильной, безопасной и англоязычной стране Европейского Союза. Университет предлагает
        качественные программы обучения по доступной стоимости, открывая глобальные возможности для студентов.
      </p>

      <h2>ОСНОВНОЙ ФОКУС — МЕДИЦИНА И БИЗНЕС</h2>
      <p>
        Мы сфокусированы на двух стратегически важных направлениях —<strong> медицина </strong> и <strong> бизнес. </strong> Эти области
        определяют развитие современного общества и рынка труда. Наши образовательные программы создаются при участии международных
        экспертов, практиков и работодателей. Обучение строится вокруг практико-ориентированных методик, развития навыков, востребованных в
        реальной профессиональной среде, и подготовке к международной сертификации.
      </p>

      <h2>МЕЖДУНАРОДНАЯ АКАДЕМИЧЕСКАЯ СРЕДА</h2>
      <p>
        MSMB — это не просто университет, а<strong> интеллектуальное пространство, </strong> объединяющее студентов из Европы, Азии, Африки
        и СНГ. Мы формируем мультикультурную академическую среду, где воспитываются толерантность, критическое мышление, лидерство и
        глобальное видение.
      </p>
      <p>
        Наш преподавательский состав — это международные эксперты, врачи, предприниматели и учёные с богатым академическим и практическим
        опытом.
      </p>

      <h2>ПРОГРАММЫ ОБУЧЕНИЯ: АКТУАЛЬНО, ГИБКО, ПЕРСПЕКТИВНО</h2>
      <p>
        Университет предлагает <strong>бакалавриат и магистратуру</strong> по европейским стандартам на английском и русском языках, с
        возможностью получения <strong>двойного диплома.</strong> MSMB аккредитован и сотрудничает с ведущими учебными заведениями ЕС.
      </p>
      <br />
      <p>
        <strong>Факультеты MSMB:</strong>
      </p>
      <ul>
        <li>
          <Link to="/">
            <strong>Факультет медицины</strong>
          </Link>
          <p>
            Программа MBBS готовит высококлассных врачей с международной квалификацией. Студенты проходят клинические стажировки и
            симуляционные тренинги, осваивая лучшие практики европейской медицины.
          </p>
        </li>
        <li>
          <Link to="/">
            <strong>Факультет бизнеса</strong>
          </Link>
          <p>
            Программы BBA и MBA включают финансы, международную торговлю, управление проектами и предпринимательство. Всё обучение
            направлено на формирование практических управленческих и лидерских навыков.
          </p>
        </li>
        <li>
          <Link to="/">
            <strong>Архитектурно-инженерный факультет</strong>
          </Link>
          <p>Подготовка специалистов в области устойчивого строительства, архитектурного дизайна и современных инженерных решений.</p>
        </li>
        <li>
          <Link to="/">
            <strong>Факультет IT</strong>
          </Link>
          <p>
            Программы по информационным технологиям, программированию, кибербезопасности и цифровым системам. Актуальные навыки — для
            цифрового мира.
          </p>
        </li>
        <li>
          <Link to="/">
            <strong>Факультет социально-гуманитарных наук</strong>
          </Link>
          <p>
            Психология, педагогика, международные отношения — всё, что формирует гуманитарную основу общества и подготавливает экспертов в
            социальной сфере.
          </p>
        </li>
        <li>
          <Link to="/">
            <strong>Факультет права</strong>
          </Link>
          <p>
            Европейское, международное и корпоративное право. Программы адаптированы для карьеры в международных организациях и юридических
            структурах ЕС.
          </p>
        </li>
      </ul>

      <h2>ВОЗМОЖНОСТИ ДЛЯ КАРЬЕРНОГО РОСТА</h2>
      <p>
        <strong>Malta School of Medicine & Business</strong> активно сотрудничает с университетами и компаниями по всему Европейскому Союзу.
        Студенты принимают участие в академических обменах, международных конференциях, клинических и бизнес-стажировках. Это — реальный
        путь к профессиональной реализации и трудоустройству в странах ЕС.
      </p>
      <br />
      <p>
        <strong>Поступайте в MSMB — сделайте шаг к международному признанию, знаниям и возможностям уже сегодня!</strong>
      </p>
    </>
  ),
  contentSearch: `
        Malta School of Medicine & Business (MSMB)  — это
        современное международное образовательное учреждение, расположенное в
        Республике Мальта — стабильной, безопасной и англоязычной стране
        Европейского Союза. Университет предлагает качественные программы обучения
        по доступной стоимости, открывая глобальные возможности для студентов.
        ОСНОВНОЙ ФОКУС — МЕДИЦИНА И БИЗНЕС
  
        Мы сфокусированы на двух стратегически важных направлениях —
        медицина и бизнес. Эти области
        определяют развитие современного общества и рынка труда. Наши
        образовательные программы создаются при участии международных экспертов,
        практиков и работодателей. Обучение строится вокруг практико-ориентированных
        методик, развития навыков, востребованных в реальной профессиональной среде,
        и подготовке к международной сертификации.
  
        МЕЖДУНАРОДНАЯ АКАДЕМИЧЕСКАЯ СРЕДА
    
        MSMB — это не просто университет, а
         интеллектуальное пространство,  объединяющее студентов из
        Европы, Азии, Африки и СНГ. Мы формируем мультикультурную академическую
        среду, где воспитываются толерантность, критическое мышление, лидерство и
        глобальное видение.

        Наш преподавательский состав — это международные эксперты, врачи,
        предприниматели и учёные с богатым академическим и практическим опытом.

        ПРОГРАММЫ ОБУЧЕНИЯ: АКТУАЛЬНО, ГИБКО, ПЕРСПЕКТИВНО
  
        Университет предлагает  бакалавриат и магистратуру  по
        европейским стандартам на английском и русском языках, с возможностью
        получения  двойного диплома.MSMB аккредитован и
        сотрудничает с ведущими учебными заведениями ЕС.

        Факультеты MSMB:
  
                Факультет медицины 
                Программа MBBS готовит высококлассных врачей с международной
                квалификацией. Студенты проходят клинические стажировки и
                симуляционные тренинги, осваивая лучшие практики европейской
                медицины.

                Факультет бизнеса 

                Программы BBA и MBA включают финансы, международную торговлю,
                управление проектами и предпринимательство. Всё обучение направлено
                на формирование практических управленческих и лидерских навыков.

                Архитектурно-инженерный факультет 

                Подготовка специалистов в области устойчивого строительства,
                архитектурного дизайна и современных инженерных решений.
                
                Факультет IT 

                Программы по информационным технологиям, программированию,
                кибербезопасности и цифровым системам. Актуальные навыки — для
                цифрового мира.
                
                Факультет социально-гуманитарных наук 

                Психология, педагогика, международные отношения — всё, что формирует
                гуманитарную основу общества и подготавливает экспертов в социальной
                сфере.

                Факультет права
                Европейское, международное и корпоративное право. Программы
                адаптированы для карьеры в международных организациях и юридических
                структурах ЕС.

                ВОЗМОЖНОСТИ ДЛЯ КАРЬЕРНОГО РОСТА
                
                Malta School of Medicine & Business активно сотрудничает
        с университетами и компаниями по всему Европейскому Союзу. Студенты
        принимают участие в академических обменах, международных конференциях,
        клинических и бизнес-стажировках. Это — реальный путь к профессиональной
        реализации и трудоустройству в странах ЕС.

        Поступайте в MSMB — сделайте шаг к международному признанию, знаниям и
        возможностям уже сегодня!
  `,
};
